import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import logoImg from '../assets/img/logo.svg'
class Header extends Component {




  render() {
    return (
      <nav className="positionAbsolute">

        <div >
          {

            this.props.authenticated
              ? (
                <Fragment>


                  <div className="btn-group">
                    <button type="button" className=" dropdownUserHeader dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <i className="fa fa-user-o" aria-hidden="true"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <Link className="dropdown-item" to="/logout"><i className="fa fa-sign-out" aria-hidden="true"></i>Logout</Link>
                      <button className="dropdown-item" data-toggle="modal" data-target="#exampleModal"><i className="fa fa-plus" aria-hidden="true"></i>Add Post</button>
                    </div>
                  </div>

                </Fragment>
              )
              : (



                <div className="btn-group">
                  <button type="button" className="dropdownUserHeader dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="fa fa-user" aria-hidden="true"></i>
                  </button>
                  <div className="dropdown-menu  dropdown-menu-right" aria-labelledby="navbarDropdown">
                    <Link className="dropdown-item" to="/login"><i className="fa fa-sign-in" aria-hidden="true"></i> Log In|Register</Link>
                  </div>
                </div>
              )
          }
        </div>

      </nav>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js